import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { PlayCircle, RotateCcw } from 'lucide-react';

interface PremiumResumeDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  assessmentTitle: string;
  onResume: () => void;
  onStartNew: () => void;
}

export default function PremiumResumeDialog({
  open,
  onOpenChange,
  assessmentTitle,
  onResume,
  onStartNew,
}: PremiumResumeDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Ongoing Assessment Found</DialogTitle>
        </DialogHeader>

        <p className="text-sm text-muted-foreground">
          You have an ongoing <span className="font-medium text-foreground">{assessmentTitle}</span> assessment. Would you like to continue where you left off or start fresh?
        </p>

        <div className="flex flex-col gap-3 mt-2">
          <Button onClick={onResume} className="w-full gap-2">
            <PlayCircle className="h-4 w-4" />
            Continue Assessment
          </Button>
          <Button variant="outline" onClick={onStartNew} className="w-full gap-2">
            <RotateCcw className="h-4 w-4" />
            Start New Assessment
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
